<mat-card class="card device-info-card">
    <mat-card-header class="card-header">
        <mat-card-title>{{'DEVICE.CONSUME' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="card-content">
        <div class="information water">
            <i class="material-icons">opacity</i> 
            <span class="element-title">{{'DEVICE.WATER' | translate}} : </span>
            {{preview?.water}}{{info?.water}}
        </div>
        <div class="information light">
            <i class="material-icons">flash_on</i>
            {{'DEVICE.LIGHT' | translate}}:
            {{preview?.light}}{{info?.light}}
        </div>
        <div class="information gas">
            <i class="material-icons">cloud</i>
            <span class="element-title">{{'DEVICE.GAS' | translate}}: </span>
            {{preview?.gas}}{{info?.gas}}
        </div>
    </mat-card-content>
</mat-card>
